__turbopack_context__.v({
  "actions": "HandoffLanding-module__AoPw9W__actions",
  "badge": "HandoffLanding-module__AoPw9W__badge",
  "badgeBlocked": "HandoffLanding-module__AoPw9W__badgeBlocked",
  "badgeCanceled": "HandoffLanding-module__AoPw9W__badgeCanceled",
  "badgeExpired": "HandoffLanding-module__AoPw9W__badgeExpired",
  "badgeFailed": "HandoffLanding-module__AoPw9W__badgeFailed",
  "badgeQueued": "HandoffLanding-module__AoPw9W__badgeQueued",
  "badgeRunning": "HandoffLanding-module__AoPw9W__badgeRunning",
  "badgeSucceeded": "HandoffLanding-module__AoPw9W__badgeSucceeded",
  "badgeUnavailable": "HandoffLanding-module__AoPw9W__badgeUnavailable",
  "badgeWaiting": "HandoffLanding-module__AoPw9W__badgeWaiting",
  "brief": "HandoffLanding-module__AoPw9W__brief",
  "card": "HandoffLanding-module__AoPw9W__card",
  "cardTitle": "HandoffLanding-module__AoPw9W__cardTitle",
  "empty": "HandoffLanding-module__AoPw9W__empty",
  "header": "HandoffLanding-module__AoPw9W__header",
  "metaGrid": "HandoffLanding-module__AoPw9W__metaGrid",
  "metaLabel": "HandoffLanding-module__AoPw9W__metaLabel",
  "metaValue": "HandoffLanding-module__AoPw9W__metaValue",
  "notice": "HandoffLanding-module__AoPw9W__notice",
  "noticeReference": "HandoffLanding-module__AoPw9W__noticeReference",
  "page": "HandoffLanding-module__AoPw9W__page",
  "pollRow": "HandoffLanding-module__AoPw9W__pollRow",
  "previewFrame": "HandoffLanding-module__AoPw9W__previewFrame",
  "reference": "HandoffLanding-module__AoPw9W__reference",
  "shell": "HandoffLanding-module__AoPw9W__shell",
  "stateRow": "HandoffLanding-module__AoPw9W__stateRow",
  "subtitle": "HandoffLanding-module__AoPw9W__subtitle",
  "title": "HandoffLanding-module__AoPw9W__title",
  "versionButton": "HandoffLanding-module__AoPw9W__versionButton",
  "versionButtonSelected": "HandoffLanding-module__AoPw9W__versionButtonSelected",
  "versionList": "HandoffLanding-module__AoPw9W__versionList",
});
